import { SaveButton } from "components/Buttons"
import TableComponent from "components/Table"
import React, { useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Card, CardBody, Col, Row } from "reactstrap"
import { downloadViewsByUser, getFeatureViewsByUser } from "store/actions"
import { getUpdatedCheckedItemsList } from "utils"
import usersListColumns from "./userListColumns"

const UserList = ({
  history,
  event_id,
  featureViewsByUser,
  getFeatureViewsByUser,
  downloadViewsByUser,
  feature_name,
  report_name,
  feature_id,
}) => {
  const [checkedItems, setCheckedItems] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([])
  const [selectedVisitors, setSelectedVisitors] = useState([])

  const handleCheckItem = (item, checked) => {
    if (checked) {
      if (
        !item?.guest_id &&
        item?.user_id &&
        selectedUsers?.indexOf(item?.user_id) === -1
      ) {
        setSelectedUsers([...selectedUsers, item?.user_id])
      }

      if (item?.guest_id && selectedVisitors?.indexOf(item?.guest_id) === -1) {
        setSelectedVisitors([...selectedVisitors, item?.guest_id])
      }
    } else {
      if (item?.guest_id) {
        let arr = [...selectedVisitors]
        arr?.splice(arr?.indexOf(item?.guest_id), 1)
        setSelectedVisitors(arr)
      } else {
        let arr = [...selectedUsers]
        arr?.splice(arr?.indexOf(item?.user_id), 1)
        setSelectedUsers(arr)
      }
    }

    let checkedItemsList = getUpdatedCheckedItemsList(
      item,
      checked,
      checkedItems
    )
    setCheckedItems(checkedItemsList)
  }

  const handleCheckAllItems = (items, checked) => {
    let list = []
    let visitors = []
    let users = []
    if (checked) {
      for (let i = 0; i < items.length; i++) {
        if (items[i]?.user_id && !items[i]?.guest_id) {
          users.push(items[i]?.user_id)
        }
        if (items[i]?.guest_id) {
          visitors.push(items[i].guest_id)
        }
        list.push(items[i].id)
      }
    }
    setSelectedUsers(users)
    setSelectedVisitors(visitors)
    setCheckedItems(list)
  }

  const handlePageChange = page => {
    getFeatureViewsByUser({
      feature: feature_name,
      page: page,
      per_page: 15,
      ...(event_id ? { event_id: event_id } : {}),
      ...(feature_id ? { feature_id: feature_id } : {}),
    })
    setCheckedItems([])
    setSelectedUsers([])
    setSelectedVisitors([])
  }

  return (
    <Card>
      <CardBody>
        <Row className="mb-3">
          <Col>
            <h4>User List</h4>
          </Col>
        </Row>
        <Row>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Send Email"
              disabled={selectedUsers?.length === 0}
              onClick={() => {
                localStorage.setItem("commUsers", JSON.stringify(selectedUsers))
                history.push(`/add-custom-email`)
              }}
            />
          </Col>
          <Col>
            <SaveButton
              type="button"
              content="Send Notification"
              disabled={
                selectedUsers?.length === 0 && selectedVisitors?.length === 0
              }
              onClick={() => {
                localStorage.setItem("commUsers", JSON.stringify(selectedUsers))
                history.push(`/add-notification`)
              }}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Download report"
              disabled={featureViewsByUser?.data?.length === 0}
              onClick={() =>
                downloadViewsByUser({
                  feature: feature_name,
                  event_id: event_id,
                  report_name: report_name,
                  page: 1,
                  per_page: 15,
                  download: 1,
                })
              }
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <TableComponent
              data={featureViewsByUser?.data?.map((x, i) => ({
                ...x,
                id: i + 1,
              }))}
              columns={usersListColumns()}
              withCheckboxes={true}
              onCheckItem={handleCheckItem}
              onCheckAllItems={handleCheckAllItems}
              paginationData={{
                current_page: featureViewsByUser?.current_page,
                last_page: featureViewsByUser?.last_page,
                total_items: featureViewsByUser?.total,
                items_per_page: featureViewsByUser?.per_page,
                from: featureViewsByUser?.from,
                to: featureViewsByUser?.to,
                first_page: 1,
              }}
              onPageChange={handlePageChange}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const mapStateToProps = state => ({
  featureViewsByUser: state.Analytics.featureViewsByUser,
})

const mapDispatchToProps = dispatch => ({
  getFeatureViewsByUser: values => dispatch(getFeatureViewsByUser(values)),
  downloadViewsByUser: values => dispatch(downloadViewsByUser(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserList))
